import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=f60d983a&scoped=true&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=f60d983a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60d983a",
  null
  
)

export default component.exports